import { render, staticRenderFns } from "./MoveToFixedSavingExplanationPopup.vue?vue&type=template&id=3a1b8c32&scoped=true"
import script from "./MoveToFixedSavingExplanationPopup.vue?vue&type=script&lang=js"
export * from "./MoveToFixedSavingExplanationPopup.vue?vue&type=script&lang=js"
import style0 from "./MoveToFixedSavingExplanationPopup.vue?vue&type=style&index=0&id=3a1b8c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1b8c32",
  null
  
)

export default component.exports